export default "__VITE_ASSET__f7bd1ab9__"